import axios from "axios";
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

export function getAnalytic(data) {
    return new Promise(resolve => {
        const path = '/api/v1/executive/analytic/getAnalytic'
        let body =
        // data
        {
            "health_area": data?.health_area,
            "province_id": data?.province_id,
            "district_id": data?.district_id
        }

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function getAnalyticLab(laboratory_id, approve_date) {
    return new Promise(resolve => {
        const path = '/api/v1/executive/analytic/getAnalytic'
        let body = {
            "laboratory_id": laboratory_id,
            "approve_date": approve_date
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function exportAnalytic(data) {
    return new Promise(resolve => {
        const path = '/api/v1/executive/analytic/exportAnalytic'
        let body = {
            "health_area": data?.health_area,
            "province_id": data?.province_id,
            "district_id": data?.district_id,
            "laboratory_id": data?.laboratory_id,
            "approve_date": data?.approve_date
        }

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function exportAnalyticData(data) {
    return new Promise(resolve => {
        const path = '/api/v1/executive/analytic/exportAnalyticData'
        let body = {
            "health_area": data?.health_area,
            "province_id": data?.province_id,
            "district_id": data?.district_id,
            "laboratory_id": data?.laboratory_id,
            "approve_date": data?.approve_date
        }

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function exportAllLabData(data) {
    return new Promise(resolve => {
        const path = '/api/v1/executive/analytic/exportAllLabData'
        let body = {
            "health_area": data?.health_area,
            "province_id": data?.province_id,
            "district_id": data?.district_id,
            "laboratory_id": data?.laboratory_id,
            "approve_date": data?.approve_date
        }

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}